export default __webpack_public_path__ + "static/green-school_4-7ffcf6348d96b1c13dc6e9a6ddd0f914.png";